import { useState } from "react";
import { Box, Stack, Typography } from "@mui/material";
import { TitledTabs } from "components/common/titledTabs";
import { useTenantTranslation } from "hooks/formatters";
import { MaterialPhysicsDefaultParameters } from "./MaterialPhysicsDefaultParameters";
import { MaterialChemistryDefaultParameters } from "./MaterialChemistryDefaultParameters";

export const MaterialPropertiesDefaultParameters = ({
  isActive,
  setConfirmOpen,
}: {
  isActive: boolean;
  setConfirmOpen: (open: boolean) => void;
}) => {
  const { t } = useTenantTranslation();
  const [selectedTabKey, setSelectedTabKey] = useState("chemistry");

  const content = (
    <>
      <Box
        hidden={selectedTabKey !== "chemistry"}
        sx={{
          display: selectedTabKey === "chemistry" ? "flex" : "none",
          flexDirection: "column",
          flex: 1,
          minHeight: 0,
        }}
      >
        <MaterialChemistryDefaultParameters
          isActive={isActive && selectedTabKey === "chemistry"}
          setConfirmOpen={setConfirmOpen}
        />
      </Box>
      <Box
        hidden={selectedTabKey !== "physics"}
        sx={{
          display: selectedTabKey === "physics" ? "flex" : "none",
          flexDirection: "column",
          flex: 1,
          minHeight: 0,
        }}
      >
        <MaterialPhysicsDefaultParameters
          isActive={isActive && selectedTabKey === "physics"}
          setConfirmOpen={setConfirmOpen}
        />
      </Box>
    </>
  );
  return (
    <Stack gap={2} sx={{ flex: 1, minHeight: 0 }}>
      <Typography variant="h2">{t("materialProperties")}</Typography>
      <Box sx={{ flex: 1, minHeight: 0 }}>
        <TitledTabs
          selectedTabKey={selectedTabKey}
          onChange={setSelectedTabKey}
          tabSpecs={[
            { key: "chemistry", title: t("chemistry"), content },
            { key: "physics", title: t("physics"), content },
          ]}
          containerSx={{ pt: 2 }}
        />
      </Box>
    </Stack>
  );
};
